"use client"

import React, { Suspense } from 'react'
import DashboardContentWrapper from '@/shared/components/dashboard-content-wrapper'
import Heading from '@/shared/components/ui/typography/heading'
import AdminTabs from './admin-tabs'
import { AdminTabLink, LegacyAdminTabLink } from '../constants/admin-tabs'
import MigrationTab from './tabs/migration-tab'
import PartnersTab from './tabs/partners-tab'
import WorkScopesTab from './tabs/work-scopes-tab'
import { RegionSettingsTab } from './tabs/region-settings-tab'
import ScrollToTopFab from '@/shared/components/scroll-to-top-fab'

interface AdminDashboardProps {
    tab?: LegacyAdminTabLink
}

function resolveAdminTab(tab?: LegacyAdminTabLink): AdminTabLink {
    if (tab === 'tools-supplies') return 'work-scopes'
    return tab ?? 'partners'
}

function AdminDashboard({ tab }: AdminDashboardProps) {
    const activeTab = resolveAdminTab(tab)

    return (
        <DashboardContentWrapper className="space-y-5 pb-24 md:pb-5">
            <div>
                <Heading>Admin Dashboard</Heading>
            </div>

            <AdminTabs tab={activeTab} />

            <div className="mt-6">
                <Suspense fallback={
                    <div className="flex items-center justify-center h-48">
                        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
                    </div>
                }>
                    {activeTab === 'region-settings' && <RegionSettingsTab />}
                    {activeTab === 'partners' && <PartnersTab />}
                    {activeTab === 'work-scopes' && <WorkScopesTab />}
                    {activeTab === 'migration' && <MigrationTab />}
                </Suspense>
            </div>
            <ScrollToTopFab />
        </DashboardContentWrapper>
    )
}

export default AdminDashboard
